export enum IncomeTypeEnum{
   Contract = "contractManagement",
   Pension = "pension",
   SoleProprietorship = "soleProprietorship",
   Farmer = "farmer",
   Retirement = "retirement",
   CommissionAgreement = "contractMandate",
   EmploymentContract = "contractEmployment",
   Rental = "placeRental",
   SocialBenefit = 'socialBenefit',
   UnionGrants = 'unionGrants',
}
